"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var functions_1 = require("./functions");
var List = /** @class */ (function () {
    function List(name) {
        this.name = name;
        this.cards = [];
    }
    List.prototype.changeName = function (newName) {
        this.name = newName;
    };
    List.prototype.addCard = function (card) {
        this.cards.push(card);
    };
    List.prototype.removeCard = function (cardPosition) {
        this.cards.splice(cardPosition, 1);
    };
    List.prototype.moveCard = function (oldPosition, newPosition) {
        (0, functions_1.arrayMove)(this.cards, oldPosition, newPosition);
    };
    return List;
}());
exports.List = List;
